<template>
  <div>
    <v-form ref="form" @submit.prevent="submitForm">
      <v-text-field
        v-model="apiToken"
        label="Request token"
        :rules="[UUIDFormat]"
      ></v-text-field>
      <v-text-field
        v-model="assetId"
        class="pr-3"
        label="Asset id"
        type="number"
        :rules="positiveIntegerRule"
      ></v-text-field>
      <v-menu
        v-model="dateMenu"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="expireDate"
            label="Expire date (optional)"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            dense
          ></v-text-field>
        </template>
        <v-date-picker v-model="expireDate"></v-date-picker>
      </v-menu>
      <v-btn width="100%" type="submit" class="mt-10">Save asset</v-btn>
    </v-form>
    <v-snackbar v-model="snackbar.show" color="red" timeout="5000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    alertMessage: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      apiToken: null,
      assetId: null,
      expireDate: null,
      dateMenu: false,
      positiveIntegerRule: [
        (v) => !!v || "Value is required",
        (v) => Number.isInteger(parseFloat(v)) || "Enter a whole number",
      ],
      snackbar: {
        message: "",
        show: false,
      },

      UUIDFormat: (v) =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
          v
        ) || "Invalid UUID format",
    };
  },
  methods: {
    submitForm: function () {
      let formData = {
        api_request_token: this.apiToken,
        platform_internal_asset_id: this.assetId,
        expires_at: this.expireDateFormatted,
      };
      this.$emit("submitAsset", formData);
    },
    closeDatePicker() {
      this.$refs.menu.closeMenu();
    },
  },
  computed: {
    expireDateFormatted: function () {
      if (this.expireDate) {
        let date = new Date(this.expireDate);
        return date.toISOString();
      }
      return null;
    },
  },
  watch: {
    alertMessage: function (value) {
      this.snackbar.message = value;
      this.snackbar.show = true;
    },
  },
};
</script>
